import {
  BASIC_BATTLE_BOT_DEF,
  BETTER_BATTLE_BOT_DEF,
  SPARK_BOT_DEF,
} from "../match/engine/content/cards"
import type {
  BasicBattleBotCard,
  BetterBattleBotCard,
  SparkBotCard,
  SystemBattleBotsConfig,
} from "../schemas"

function cloneBasicBattleBot(): BasicBattleBotCard {
  return {
    ...BASIC_BATTLE_BOT_DEF,
    id: "basic_battle_bot",
    kind: "starter",
    stats: { ...BASIC_BATTLE_BOT_DEF.stats },
    selectedSkills: BASIC_BATTLE_BOT_DEF.selectedSkills.map((skill) => ({
      ...skill,
    })),
    authoredCostInputs: { ...BASIC_BATTLE_BOT_DEF.authoredCostInputs },
  }
}

function cloneSparkBot(): SparkBotCard {
  return {
    ...SPARK_BOT_DEF,
    id: "spark_bot",
    kind: "starter",
    stats: { ...SPARK_BOT_DEF.stats },
    selectedSkills: SPARK_BOT_DEF.selectedSkills.map((skill) => ({ ...skill })),
    authoredCostInputs: { ...SPARK_BOT_DEF.authoredCostInputs },
  }
}

function cloneBetterBattleBot(): BetterBattleBotCard {
  return {
    ...BETTER_BATTLE_BOT_DEF,
    id: "better_battle_bot",
    kind: "better_battle_bot",
    stats: { ...BETTER_BATTLE_BOT_DEF.stats },
    selectedSkills: BETTER_BATTLE_BOT_DEF.selectedSkills.map((skill) => ({
      ...skill,
    })),
    authoredCostInputs: { ...BETTER_BATTLE_BOT_DEF.authoredCostInputs },
  }
}

export function createDefaultSystemBattleBotsConfig(
  updatedAt: string = new Date().toISOString(),
): SystemBattleBotsConfig {
  return {
    basicBattleBot: cloneBasicBattleBot(),
    sparkBot: cloneSparkBot(),
    betterBattleBot: cloneBetterBattleBot(),
    updatedAt,
  }
}

export const DEFAULT_SYSTEM_BATTLE_BOTS_CONFIG =
  createDefaultSystemBattleBotsConfig("2026-03-28T00:00:00.000Z")
